import buildMonths from './buildMonths'
import { defaultToday, defaultMaxDate } from '../CalendarRoot'

export function calendarRootWillReceiveProps(props, nextProps) {
  const minDate = nextProps.minDate || defaultToday
  const maxDate = nextProps.maxDate || defaultMaxDate

  if (parseInt(minDate) !== props.minDate || parseInt(maxDate) !== props.maxDate) {
    return {
      ...nextProps,
      months: buildMonths(minDate, maxDate, props.startsWithSunday, props.locale),
    }
  }

  if (nextProps.startsWithSunday !== props.startsWithSunday || nextProps.locale !== props.locale) {
    return {
      ...nextProps,
      months: buildMonths(props.minDate, props.maxDate, nextProps.startsWithSunday, nextProps.locale),
    }
  }

  return null
}
